import { useState } from 'react';

// The round brand mark on the phone's car cards and vehicle page.
//
// To show a real logo, add a transparent PNG named after the brand to public/brand/makes/
// (lower case, spaces become dashes): bmw.png, porsche.png, aston-martin.png, land-rover.png …
// Until a file exists the badge shows the brand's initials, so nothing ever looks broken.

const slug = (b = '') => String(b).normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const initials = (b = '') => {
  const name = String(b).trim();
  if (!name) return '?';
  if (name.length <= 3) return name.toUpperCase();          // BMW, MG, VW
  const words = name.split(/\s+/).filter(Boolean);
  return words.length > 1 ? words.map(w => w[0]).join('').slice(0, 2).toUpperCase() : name[0].toUpperCase();
};

export const MakeBadge = ({ brand, size = 44, className = '' }) => {
  const [failed, setFailed] = useState(false);
  const file = slug(brand);
  return (
    <span className={`cx-badge ${className}`} style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }} aria-hidden="true">
      {file && !failed
        ? <img src={`/brand/makes/${file}.png`} alt="" onError={() => setFailed(true)} />
        : <span className="cx-badge-t">{initials(brand)}</span>}
    </span>
  );
};
